import { useEffect, useState } from "react";
import axios from "axios";
import { X, BarChart3, Download, Mail, Eye, MessageSquare, FileText } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Insights = ({ open, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    axios
      .get(`${API}/analytics/summary`)
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [open]);

  if (!open) return null;

  const t = data?.totals || {};
  const tiles = [
    { icon: Eye, label: "Page Views", value: t.page_view ?? 0 },
    { icon: Download, label: "Capability Downloads", value: t.capability_download ?? 0 },
    { icon: FileText, label: "Report Downloads", value: t.sample_download ?? 0 },
    { icon: Mail, label: "Contact Submissions", value: t.contact_submit ?? 0 },
    { icon: MessageSquare, label: "Assistant Opens", value: t.chat_open ?? 0 },
  ];
  const convRate = t.page_view ? Math.round(((t.contact_submit || 0) / t.page_view) * 100) : 0;

  return (
    <div className="insights-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label="Engagement insights">
      <div className="insights-panel" onClick={(e) => e.stopPropagation()} data-testid="insights-panel">
        <div className="insights-head">
          <BarChart3 size={18} />
          <span>Engagement Insights</span>
          <button className="insights-close" onClick={onClose} aria-label="Close insights" data-testid="insights-close">
            <X size={18} />
          </button>
        </div>
        {loading ? (
          <div className="insights-loading">Loading…</div>
        ) : (
          <>
            <div className="insights-grid">
              {tiles.map(({ icon: Icon, label, value }) => (
                <div className="insights-tile" key={label} data-testid={`insight-${label.replace(/\s/g, "-").toLowerCase()}`}>
                  <Icon size={18} className="insights-tile-icon" />
                  <div className="insights-tile-value">{value}</div>
                  <div className="insights-tile-label">{label}</div>
                </div>
              ))}
            </div>
            <div className="insights-foot">
              {convRate}% of visits convert to a contact · {data?.total_events ?? 0} total events tracked
            </div>
            {data?.report_downloads?.length > 0 && (
              <div className="insights-reports" data-testid="insights-report-breakdown">
                <div className="insights-reports-head">Report downloads by title</div>
                {data.report_downloads.map((r) => (
                  <div className="insights-report-row" key={r.title}>
                    <span className="insights-report-title">{r.title}</span>
                    <span className="insights-report-count">{r.count}</span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
